export default "__VITE_ASSET___Dtahndw__"